import axios from 'axios';

class NetworkService {
  getNetwork(slug) {
    let url = '/networks/' + slug;
    return axios
      .get(url)
      .then(resp => {
        return resp.data;
      })
      .catch(error => {
        console.log('error', error.response);
        return false;
      });
  }

  getAll(query = null) {
    let url = 'networks/all';
    if (query) url += '?query=' + query;

    return axios
      .get(url)
      .then(resp => {
        return resp.data;
      })
      .catch(error => {
        console.log('error', error.response);
        return false;
      });
  }

  getTrending(query = null) {
    let url = 'networks/trending_networks';
    if (query) url += '?query=' + query;

    return axios
      .get(url)
      .then(resp => {
        return resp.data;
      })
      .catch(error => {
        console.log('error', error.response);
        return false;
      });
  }

  getUserData() {
    let url = 'my-data';

    return axios
      .get(url)
      .then(resp => {
        return resp.data;
      })
      .catch(error => {
        console.log('error', error.response);
        return false;
      });
  }

  deleteImage(network_slug, field, image_path) {
    // delete image
    let url = '/networks/delete/' + network_slug + '/image';

    var formData = new FormData();
    formData.append('network_slug', network_slug);
    formData.append('field', field);
    formData.append('image_path', image_path);

    return axios.post(url, formData).then(res => {
      return res;
    });
  }

  toggleLike(slug) {
    let url = 'networks/' + slug + '/toggle-like';
    return axios.post(url).then(resp => resp.data);
  }
}

// https://k94n.com/es6-modules-single-inst
export let networkservice = new NetworkService();
export default networkservice;
